module.exports = __webpack_public_path__ + "static/media/bnr_reia792a4461c6d6623c878f0977dd2516b.webp";